import { useAppDispatch, useAppSelector } from "../Redux/Hooks";
import {
  createRechargeOrder,
  verifyRecharge,
  cancelRechargeOrder,
  getWalletBalance,
} from "../Redux/ApiCalls/Dashboard/WhatsAppAPI";
import { loadCashfree, getCashfreeMode } from "../Utils/cashfree";

export function useWalletRecharge() {
  const { rechargeOrder, rechargeLoading, rechargeVerifying, walletBalance } = useAppSelector(
    (state) => state.whatsapp
  );
  const dispatch = useAppDispatch();

  const initiateRecharge = async (amount: string) => {
    const returnUrl = `${window.location.origin}/dashboard/whatsapp/billing`;
    const result = await dispatch(createRechargeOrder({ amount, return_url: returnUrl })).unwrap();
    return result;
  };

  const openCashfreeCheckout = async (sessionId: string, orderId: string) => {
    const mode = getCashfreeMode();
    const cashfree = await loadCashfree(mode);
    cashfree.checkout({ paymentSessionId: sessionId });
  };

  const verifyPayment = async (orderId: string) => {
    const result = await dispatch(verifyRecharge({ order_id: orderId })).unwrap();
    dispatch(getWalletBalance());
    return result;
  };

  const cancelOrder = async (orderId: string) => {
    const result = await dispatch(cancelRechargeOrder({ order_id: orderId })).unwrap();
    return result;
  };

  return {
    rechargeOrder,
    rechargeLoading,
    rechargeVerifying,
    walletBalance,
    initiateRecharge,
    openCashfreeCheckout,
    verifyPayment,
    cancelOrder,
  };
}
